const de = {
  common: {
    loading: "Laden...",
    close: "Schließen",
    submit: "Einreichen",
    review: "Rezension",
    help: "Helfen",
    tour: "Tour",
    instructions: "Anweisungen",
    language: "Sprache",
    ok: "OK",
    appLoaderText:
      "Laden... Bitte warten Sie, während wir Ihre Bewertungsumgebung vorbereiten."
  },
  assessment: {
    fetchError: "Fehler beim Abrufen der {{featureName}}",
    somethingWentWrong: "Etwas ist schief gelaufen.",
    goBackToDashboard: "Gehen Sie zurück zum Dashboard",
    confirmSubmissionTitle: "Bestätigen Sie die Übermittlung",
    scheduleIdNotFound: "Zeitplan-ID nicht gefunden",
    ongoingIdNotFound: "Laufende ID nicht gefunden",
    errorFetchingOngoingData: "Fehler beim Abrufen laufender Daten",
    connectionRestoredLabel: "Verbindung wiederhergestellt.",
    connectionRestoredDescription: "Sie können weiterhin Testfälle ausführen.",
    connectionLostLabel: "Wir haben die Verbindung zum Testserver verloren.",
    connectionLostDescription:
      "Sie können derzeit keine Testfälle ausführen oder validieren.",
    featureNames: {
      assessment: "Bewertung",
      knowledgeCheck: "Wissenscheck"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "Wird gestartet",
      expired: "Abgelaufen",
      expiringSoon: "Läuft bald ab",
      ongoing: "Laufend"
    },
    cardState: {
      draft: "Entwurf",
      published: "Veröffentlicht",
      cancelled: "Abgebrochen",
      inreview: "In Prüfung",
      readytopublish: "Bereit zur Veröffentlichung",
      sentback: "Zurückgesendet"
    },
    dashboard: {
      videoProctoring: "Videoüberwachung",
      submitFeature: "Senden Sie {{featureName}}",
      noSectionsFound: "Keine Abschnitte gefunden",
      expandAllSections: "Erweitern Sie alle Abschnitte",
      closeAllSections: "Alle Abschnitte schließen",
      continueShapingAssessments: "Gestalten Sie Ihre Bewertungen weiter",
      viewAll: "Alle anzeigen",
      legend: {
        notStarted: "Nicht gestartet",
        inProgress: "Im Gange",
        completed: "Vollendet"
      }
    },
    confirmModal: {
      description:
        "Nach der Übermittlung können Sie keine Änderungen mehr an Ihrer {{featureName}} vornehmen. Bitte überprüfen Sie Ihre Antworten, bevor Sie sie bestätigen. Möchten Sie mit der Einreichung fortfahren?",
      lowWordCountWarning:
        "Ihre Antwort auf die Frage {{questionTitle}} besteht aus weniger als 40 Wörtern. Wenn Sie die Bewertung jetzt absenden, wird diese Antwort nicht gespeichert.",
      videoNotSubmittedWarning:
        "Ihr aufgezeichnetes Video für die Frage {{questionTitle}} wurde nicht übermittelt. Wenn Sie die Bewertung jetzt absenden, wird diese Antwort verworfen.",
      unansweredQuestions: "Sie haben {{count}} unbeantwortete Fragen",
      andFlaggedQuestions: "und {{count}} markierte Fragen",
      failedToFinish: "{{featureName}} konnte nicht abgeschlossen werden"
    },
    feedback: {
      submittedTitle: "Ihre {{featureName}} wurde erfolgreich übermittelt!",
      submittedDescription:
        "Ihre Antworten wurden übermittelt. Wir danken Ihnen für die Zeit und Mühe, die Sie in die Fertigstellung dieser {{featureName}} gesteckt haben!",
      resultInProgress:
        "Das Ergebnis wird berechnet und kann bis zu einer Minute dauern. Bitte warten...",
      resultReady:
        "Ergebnis ist fertig! Klicken Sie auf die Schaltfläche „Ergebnis anzeigen“, um es anzuzeigen.",
      resultDelayed:
        "Die Ergebnisberechnung dauert länger als gewöhnlich. Bitte kontaktieren Sie den Administrator für Ihr Ergebnis.",
      showResult: "Ergebnis anzeigen",
      redirectingToResult:
        "Weiterleitung zur Ergebnisseite in {{seconds}} Sekunden, wenn Sie nicht auf die Schaltfläche „Ergebnis anzeigen“ klicken",
      shareFeedbackTitle: "Teilen Sie Ihr Feedback",
      shareFeedbackDescription:
        "Ihre Erkenntnisse ebnen den Weg für Wachstum. Lasst uns gemeinsam aufsteigen!",
      errorSubmittingFeedback: "Fehler beim Senden des Feedbacks",
      feedbackSubmittedTitle: "Alles klar, Feedback ist eingereicht!",
      feedbackSubmittedDescription:
        "Ihr Feedback wurde übermittelt. Vielen Dank, dass Sie uns dabei helfen, das {{featureName}}-Erlebnis zu verbessern!",
      feedbackAlreadySubmittedTitle: "Alles klar, Feedback bereits abgegeben!",
      feedbackAlreadySubmittedDescription:
        "Anscheinend haben Sie das Feedback bereits abgegeben. Vielen Dank, dass Sie uns dabei helfen, das {{featureName}}-Erlebnis zu verbessern!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Fehler beim Abrufen der Vorbewertungsdaten",
      connectionRestoredLabel: "Verbindung wiederhergestellt.",
      connectionRestoredDescription:
        "Deine letzten Änderungen werden synchronisiert...",
      offlineLabel: "Sieht aus, als wärst du offline.",
      offlineDescription:
        "Änderungen werden erst synchronisiert, wenn Sie die Verbindung wiederherstellen"
    },
    question: {
      questions: "Fragen",
      closeQuestionsPanel: "Schließen Sie den Fragenbereich",
      collapse: "Zusammenbruch",
      sectionSummary: "Abschnittszusammenfassung",
      sections: "Abschnitte",
      toggleQuestionsPanel: "Fragenbereich umschalten",
      switchModal: {
        switchQuestionButton: "Frage wechseln",
        leaveHeading: "Sind Sie sicher, dass Sie gehen möchten?",
        discardMessage:
          "Sie haben nicht gespeicherte Änderungen. Wenn Sie die Frage ändern, wird Ihre Antwort dauerhaft gelöscht.",
        saveChangesButton: "Änderungen speichern",
        saveHeading: "Möchten Sie die Änderungen speichern?",
        saveBeforeSwitchMessage:
          "Sie haben nicht gespeicherte Änderungen. Möchten Sie diese speichern, bevor Sie die Frage ändern?"
      }
    },
    faq: {
      q1: {
        question: "Was sollte ich tun, bevor ich {{featureName}} starte?",
        firstSentence:
          "Bitte stellen Sie sicher, dass Sie Folgendes abgeschlossen haben:",
        list: {
          item1: "Eine stabile Internetverbindung",
          item2:
            "Eine funktionierende Webcam und ein funktionierendes Mikrofon (sofern die Videoüberwachung aktiviert ist)",
          item3: "Eine ruhige, ablenkungsfreie Umgebung",
          item4:
            "Wenn die Videoüberwachung aktiviert ist, werden Sie aufgefordert, eine Systemprüfung durchzuführen.",
          item5:
            "Lesen Sie die Allgemeinen Geschäftsbedingungen und stimmen Sie ihnen zu"
        }
      },
      q2: {
        question:
          "Kann ich während der {{featureName}} zwischen Fragen oder Abschnitten navigieren?",
        firstSentence: "Die Navigation hängt von den Einstellungen ab.",
        list: {
          item1:
            "Wenn die Abschnittsnavigation aktiviert ist, können Sie zwischen Abschnitten wechseln.",
          item2:
            "Wenn die Funktion deaktiviert ist, müssen Sie einen Abschnitt abschließen, bevor Sie mit dem nächsten fortfahren können."
        },
        lastSentence:
          "Anweisungen sind während der {{featureName}} jederzeit verfügbar."
      },
      q3: {
        question: "Werde ich während des Tests überwacht?",
        list: {
          item1:
            "Wenn für diese {{featureName}} die Videoüberwachung aktiviert ist, werden Ihre Kamera und Ihr Mikrofon verwendet.",
          item2:
            "Jede ungewöhnliche Aktivität kann zur Überprüfung markiert werden."
        }
      },
      q4: {
        question:
          "Was passiert, wenn ich die Internetverbindung verliere oder den Browser versehentlich schließe?",
        firstSentence: "Ihr Fortschritt wird automatisch gespeichert.",
        lastSentence:
          "Sollte es zu einer Verbindungsunterbrechung kommen, können Sie sich über denselben Link erneut mit {{featureName}} verbinden."
      },
      q5: {
        question:
          "Kann ich meine Ergebnisse oder mein Feedback nach dem Test sehen?",
        firstSentence:
          "Ergebnisse und Feedback werden vom {{featureName}}-Organisator konfiguriert.",
        list: {
          item1:
            "Wenn diese Option aktiviert ist, sehen Sie nach der Übermittlung Ihre Punktzahl und die Zusammenfassung Ihres Feedbacks.",
          item2:
            "Wenn nicht, werden Ihre Ergebnisse über Ihre registrierte E-Mail-Adresse geteilt."
        }
      }
    },
    labels: {
      totalDuration: "Gesamtdauer",
      numberOfQuestions: "Anzahl der Fragen",
      numberOfSections: "Anzahl der Abschnitte",
      guidelines: "Richtlinien",
      platformHelp: "Plattformhilfe",
      faq: "FAQ",
      sidebar: {
        home: "Startseite",
        quickAccess: "Schnellzugriff",
        questionPaperAuthoring: "Fragenbogenerstellung",
        assessmentLibrary: "Bewertungsbibliothek",
        scheduleInterview: "Interview planen",
        generateQuestions: "Fragen generieren",
        roleManagement: "Rollenverwaltung",
        logout: "Abmelden",
        noAccess: "Kein Zugriff",
        noAccessWithLabel: "{{label}} (Kein Zugriff)",
        noAccessToLink: "Sie haben keinen Zugriff auf diesen Link",
        expandSidebar: "Seitenleiste erweitern",
        collapseSidebar: "Seitenleiste einklappen",
        expand: "Erweitern",
        collapse: "Einklappen",
        myPreferences: "Meine Einstellungen"
      },
      frequentlyAskedQuestions: "Häufig gestellte Fragen",
      showFeatureInstructions: "{{featureName}} Anweisungen anzeigen",
      minutes: "Minuten",
      welcome: "Willkommen",
      welcomeBack: "Willkommen zurück",
      userFallback: "Benutzer",
      defaultGuidelines:
        "Stellen Sie vor Beginn der {{featureName}} sicher, dass Sie sich an einem ruhigen, ablenkungsfreien Ort mit einer stabilen Internetverbindung befinden. Lassen Sie Ihre Kamera während des gesamten Tests eingeschaltet und planen Sie Ihre Zeit sinnvoll ein, da es ein Zeitlimit gibt. Wenn Sie auf technische Probleme stoßen, wenden Sie sich umgehend an den Support. Wenn Sie fertig sind, überprüfen Sie Ihre Antworten, bevor Sie sie absenden. Viel Glück!"
    },
    zoom: {
      textSize: "Textgröße:",
      decreaseTextSize: "Textgröße verringern (A-)",
      resetTextSize: "Textgröße zurücksetzen (A)",
      increaseTextSize: "Textgröße erhöhen (A+)"
    },
    wrapper: {
      warningTitle: "Warnung!",
      stayOnPageMessage:
        "Bitte bleiben Sie auf dieser Seite, bis Sie die {{featureName}} abgeschlossen haben.",
      iUnderstand: "Ich verstehe",
      submitTheFeature: "Senden Sie die {{featureName}}",
      videoProctoringInterrupted: "Videoüberwachung unterbrochen",
      continuationBlocked:
        "Die Fortsetzung der Bewertung ist blockiert, bis die sichere Videoüberwachung wiederhergestellt ist.",
      retryProctoring: "Versuchen Sie die Überwachung erneut"
    },
    progress: {
      proceed: "Fortfahren",
      resumeFeature: "{{featureName}} fortsetzen",
      timeRemainingMessage:
        "verbleibt in der {{featureName}}. Klicken Sie unten, um dort weiterzumachen, wo Sie aufgehört haben.",
      continueOnThisDevice: "Auf diesem Gerät fortfahren?",
      switchToThisTab: "Zu diesem Tab wechseln?",
      continueYourAssessmentHere: "Möchten Sie Ihre Bewertung hier fortsetzen?",
      switchHere: "Hier wechseln",
      attemptsUnlimited:
        "Für diese Beurteilung stehen Ihnen unbegrenzt viele Versuche zur Verfügung.",
      attemptsSingle:
        "Für diese Beurteilung stehen Ihnen <strong>1</strong> Versuche zur Verfügung.",
      attemptsMultiple:
        "Für diese Beurteilung stehen Ihnen <strong>{{remainingAttempts}}</strong> von <strong>{{maxAttempts}}</strong> Versuchen zur Verfügung.",
      coolOffAfterAttempt:
        "Nach jedem Versuch müssen Sie <strong>{{coolOffTime}}</strong> warten, bevor Sie mit dem nächsten Versuch beginnen."
    },
    loginWindow: {
      expiredTitle: "Anmeldezeit abgelaufen",
      expiredMessage:
        "Das Anmeldefenster für diese {{featureName}} ist jetzt geschlossen. Sie haben die zulässige Zeit für den Zugriff auf den Test verpasst."
    },
    coding: {
      saving: "Sparen",
      offlineTitle: "Sieht aus, als wärst du offline",
      offlineDescription:
        "Änderungen werden erst synchronisiert, wenn Sie die Verbindung wiederherstellen",
      connectionRestored: "Verbindung wiederhergestellt",
      syncingLatest: "Deine letzten Änderungen werden synchronisiert...",
      autoSaveEnabled: "Automatisches Speichern aktiviert",
      runOnlyChecksDescription:
        "überprüft Ihren Code nur anhand von Testfällen.",
      submitEvaluationDescription:
        "Ihren Code zur Bewertung einreichen und Punkte erhalten.",
      reset: "Zurücksetzen",
      run: "Ausführen",
      runTests: "Ausführen von Tests",
      submit: "Einreichen",
      submitting: "Einreichen",
      resetCode: "Code zurücksetzen",
      resetCodeMessage:
        "Möchten Sie wirklich zurücksetzen? Dadurch wird Ihr gesamter aktueller Code entfernt und der Startercode wiederhergestellt",
      testCases: "Testfälle",
      testCase: "Testfall {{index}}",
      testCasePassed: "Testfall bestanden",
      testCaseFailed: "Testfall fehlgeschlagen",
      runtimeError: "Laufzeitfehler",
      timeLimitExceeded: "Zeitlimit überschritten",
      timeLimitExceededTitle: "Zeitlimit überschritten",
      timeLimitExceededDescription:
        "Ihr Code wurde nicht innerhalb der Zeitvorgaben ausgeführt. Bitte optimieren Sie Ihren Code.",
      input: "Eingang",
      expectedOutput: "Erwartete Ausgabe",
      yourOutput: "Ihre Ausgabe",
      hiddenTestCase: "Versteckter Testfall",
      hiddenTestCaseDescription:
        "Versteckte Testfälle werden verwendet, um zu bewerten, ob Ihr Code verschiedene Szenarien, einschließlich Eckfälle, bewältigen kann",
      explanation: "Erläuterung",
      hints: "Hinweise"
    },
    subjective: {
      minWordsRequired:
        "Zur Übermittlung der Antwort sind mindestens 40 Wörter erforderlich.",
      enterYourAnswer: "Geben Sie Ihre Antwort ein",
      submitResponse: "Antwort senden",
      submittingResponse: "Antwort wird gesendet...",
      resetAnswer: "Antwort zurücksetzen",
      resetAnswerMessage:
        "Möchten Sie wirklich zurücksetzen? Ihre aktuelle Antwort wird dauerhaft entfernt.",
      retake: "Wiederholung",
      showHint: "Hinweis anzeigen",
      recording: "AUFNAHME"
    },
    systemCheck: {
      calibrate: "Kalibrieren",
      calibrating: "Kalibrieren...",
      accessDenied: "Zugriff verweigert",
      cameraPermissionDenied:
        "Erlaubnis für Kamera verweigert. Bitte aktivieren Sie den Kamerazugriff in Ihren Browsereinstellungen, um fortzufahren.",
      errorFetchingDevices: "Fehler beim Abrufen der Geräte",
      failedToStartAssessment: "Die Bewertung konnte nicht gestartet werden",
      unableToStartSecureProctoring:
        "Die sichere Überwachung kann derzeit nicht gestartet werden. Bitte versuchen Sie es erneut.",
      unnamedCamera: "Unbenannte Kamera",
      facingCalibrationIssues: "Haben Sie Probleme mit der Videokalibrierung?",
      lookAtCenter:
        "Schauen Sie bitte in die Mitte des Bildschirms und bleiben Sie ruhig.",
      unableToCalibrateTitle:
        "Sie können Ihre Kamera nicht für die Videoüberwachung kalibrieren?",
      statusMessages: {
        readyForCalibration:
          "Stellen Sie sicher, dass Ihr Gesicht deutlich sichtbar und zentriert auf dem Bildschirm ist. Wenn Sie fertig sind, klicken Sie auf „Kalibrieren“, um zu beginnen.",
        calibratingInProgress:
          "Kalibrierung läuft. Schauen Sie weiter auf den Bildschirm.",
        calibratingTimedOut:
          "Zeitüberschreitung bei der Kamerakalibrierung. Bitte aktualisieren Sie Ihren Browser, um fortzufahren.",
        preparingCameraPreview:
          "Kamerastream und Gesichtsverfolgung werden für die Kalibrierung vorbereitet.",
        retryRequired:
          "Für die Überwachungseinrichtung ist Ihr Eingreifen erforderlich, bevor Sie fortfahren können.",
        proctoringUnavailable:
          "Die Aufsicht ist derzeit nicht verfügbar und die Bewertung kann nicht sicher gestartet werden.",
        calibrationCompleted:
          "Kalibrierung erfolgreich! Sie sind bereit, mit der Bewertung zu beginnen.",
        timeoutHelp:
          "Wenn diese Meldung weiterhin angezeigt wird, prüfen Sie, ob andere Registerkarten/Apps die Kamera oder einen externen Verschluss verwenden."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Die Kameraberechtigung ist blockiert. Erlauben Sie den Zugriff und versuchen Sie es erneut.",
        cameraUnavailable:
          "Die Kamera ist nicht verfügbar. Überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
        facemeshInitFailed:
          "Die Einrichtung der Gesichtsverfolgung ist fehlgeschlagen. Versuchen Sie es erneut, um fortzufahren.",
        cocoLoadFailed:
          "Die Proctoring-Engine ist nicht verfügbar. Aktualisieren Sie und versuchen Sie es erneut.",
        streamLostReacquireFailed:
          "Die Wiederherstellung des Kamerastreams ist fehlgeschlagen. Versuchen Sie die Überwachung erneut.",
        calibrationInsufficientData:
          "Die Kalibrierungsproben waren unzureichend. Versuchen Sie die Kalibrierung erneut.",
        detectionCadenceUnavailable:
          "Die Timing-Konfiguration ist nicht bereit. Versuchen Sie es in Kürze noch einmal."
      },
      calibrationInfo: {
        heading:
          "Um Ihr Video erfolgreich zu kalibrieren, befolgen Sie bitte diese Schritte:",
        followUpHeading:
          "Wenn das Problem weiterhin besteht, führen Sie die folgenden Schritte aus:",
        initialSteps: {
          step1: {
            title: "Sorgen Sie für eine gute Beleuchtung",
            description:
              "Setzen Sie sich an einen gut beleuchteten Ort, sodass Ihr Gesicht deutlich sichtbar ist. Vermeiden Sie helles Licht oder Fenster hinter Ihnen."
          },
          step2: {
            title: "Schauen Sie direkt in die Kamera",
            description:
              "Positionieren Sie Ihr Gesicht in der Mitte des Bildes und schauen Sie während der Kalibrierung direkt in die Kamera."
          },
          step3: {
            title: "Vermeiden Sie dunkle oder verschwommene Hintergründe",
            description:
              "Stellen Sie sicher, dass Ihr Hintergrund klar und nicht zu dunkel ist."
          },
          step4: {
            title: "Überprüfen Sie die Kameraberechtigungen",
            description:
              "Erlauben Sie Ihrem Browser den Zugriff auf die Webcam, wenn Sie dazu aufgefordert werden."
          },
          step5: {
            title: "Bleiben Sie ruhig und schauen Sie auf den Bildschirm",
            description:
              "Halten Sie während der Kalibrierung Ihren Kopf ruhig, damit das System Ihr Gesicht richtig erkennen kann."
          }
        },
        laterSteps: {
          step1:
            "Versuchen Sie, die Seite zu aktualisieren und Ihre Kamera neu zu kalibrieren.",
          step2:
            "Schließen Sie andere Apps über die Webcam (wie Zoom oder Teams).",
          step3:
            "Wenn das Problem weiterhin besteht, wenden Sie sich mit einem Screenshot des Fehlers an {{contactEmail}}."
        }
      }
    },
    stepper: {
      termsAndConditions: "Geschäftsbedingungen",
      agreeTerms:
        "Ich habe die Allgemeinen Geschäftsbedingungen gelesen und bin damit einverstanden.",
      previousStep: "Vorheriger Schritt",
      nextStep: "Nächster Schritt",
      startAssessment: "Bewertung starten",
      resumeAssessment: "Bewertung fortsetzen",
      mediaCheck: "Mediencheck",
      systemCheck: "Systemprüfung",
      audioCheck: {
        intro:
          "Sie können hier ein kurzes Video aufnehmen, um zu überprüfen, ob Kamera und Mikrofon wie erwartet funktionieren.",
        mediaPermissionDenied:
          "Der Zugriff auf Kamera oder Mikrofon wurde verweigert. Bitte aktivieren Sie die Berechtigungen in Ihren Browsereinstellungen.",
        startRecording: "Aufnahme starten",
        stopRecording: "Aufnahme stoppen",
        unnamedMicrophone: "Unbenanntes Mikrofon"
      },
      stepLabel: "SCHRITT {{step}}",
      personalDetails: "Persönliche Daten",
      emailId: "E-Mail-ID",
      firstName: "Vorname",
      lastName: "Nachname",
      defaultTncStatement:
        "Durch die Teilnahme an dieser Beurteilung bestätigen Sie, dass Sie die vom Unternehmen festgelegten Zulassungsvoraussetzungen erfüllen und erklären sich damit einverstanden, den Test selbstständig und ohne externe Hilfe durchzuführen. Die Beurteilung unterliegt einer Videoüberwachung und Sie müssen Ihre Kamera während der gesamten Sitzung in einer ablenkungsfreien Umgebung eingeschaltet haben. Alle während der Bewertung bereitgestellten Inhalte und Materialien sind vertraulich und dürfen nicht weitergegeben, reproduziert oder verbreitet werden. Sie erklären sich damit einverstanden, die festgelegte Frist für die Beurteilung einzuhalten; Eine Nichteinreichung vor Ablauf der Frist kann zur Disqualifikation führen. Das Unternehmen haftet nicht für technische Probleme im Zusammenhang mit Ihrer Internetverbindung, Software oder Hardware. Die im Rahmen der Beurteilung erhobenen personenbezogenen Daten werden ausschließlich zu Bewertungs- und Rekrutierungszwecken gemäß der Datenschutzrichtlinie des Unternehmens verarbeitet. Jeder Versuch, zu betrügen, zu plagiieren oder sich anderweitig unethisch zu verhalten, führt zur sofortigen Disqualifikation. Mit der Übermittlung Ihrer Antworten bestätigen Sie, dass diese endgültig sind und nach der Übermittlung keine Änderungen mehr vorgenommen werden können. Das Unternehmen behält sich das Recht vor, diese Bedingungen jederzeit zu ändern oder zu aktualisieren, und die Teilnehmer werden über alle wesentlichen Änderungen informiert.",
      okay: "Okay"
    },
    access: {
      cancelledTitle: "„{{title}}“ wurde abgebrochen",
      cancelledDescription:
        "Diese Bewertung ist nicht mehr aktiv und kann nicht aufgerufen werden. Bitte überprüfen Sie Ihr Dashboard auf andere zugewiesene oder bevorstehende Bewertungen.",
      goToHome: "Gehen Sie zu Startseite",
      refreshPage: "Seite aktualisieren"
    },
    errorPage: {
      goBack: "Zurück",
      raiseRequest: "Anfrage stellen",
      retryLogin: "Erneut anmelden",
      contactUs: "Kontaktieren Sie uns",
      goBackToEvent: "Zurück zum Event",
      launchCourse: "Kurs starten",
      created: "Erstellt",
      starts: "Beginnt",
      ends: "Endet",
      untitled: "Ohne Titel"
    },
    timesUp: {
      title: "Bewertungszeit abgeschlossen",
      autoSubmittedMessage:
        "Der Timer ist abgelaufen. Ihre Antworten wurden gespeichert und die {{featureName}} wurde automatisch übermittelt."
    },
    resultCard: {
      title: "{{featureName}} Ergebnisse",
      score: "Punktzahl",
      passPercentage: "Erfolgsquote",
      marksAway:
        "Sie sind noch {{count}} Punkte von der Zertifizierung entfernt. Konzentrieren Sie sich auf die empfohlenen Bereiche und versuchen Sie es erneut.",
      certificationEarned:
        "Sie haben die Zertifizierungsanforderungen übertroffen und Ihre Zertifizierung erhalten",
      congratulationsOnEarning:
        "Herzlichen Glückwunsch zum Erwerb der {{featureName}}-Zertifizierung",
      almostThereTitle: "Sie sind der Zertifizierung näher als Sie denken",
      certificatePassedDescription:
        "Sie haben die für die Erlangung dieser Zertifizierung erforderlichen Kenntnisse und Fähigkeiten nachgewiesen. Nehmen Sie sich einen Moment Zeit, um diesen Erfolg zu feiern und ihn mit Ihrem Netzwerk zu teilen",
      certificateFailDescription:
        "Dieser Versuch zeigte Möglichkeiten auf, Ihre Fähigkeiten zu stärken. Überprüfen Sie die empfohlenen Bereiche und kehren Sie mit Zuversicht zurück",
      congratsImageAlt: "Herzlichen Glückwunsch, Bild",
      almostThereImageAlt: "Fast da. Bild"
    },
    sectionCard: {
      section: "Abschnitt",
      startSection: "Startabschnitt",
      continueSection: "Abschnitt „Fortfahren“.",
      completed: "Vollendet",
      viewSection: "Abschnitt anzeigen",
      totalQuestions: "Gesamtzahl der Fragen:",
      sectionNotFound: "Abschnitt nicht gefunden.",
      total: "Gesamt",
      flagged: "Gekennzeichnet"
    },
    sectionSummary: {
      totalQuestions: "Gesamtzahl der Fragen",
      completedQuestions: "Abgeschlossene Fragen",
      flaggedQuestions: "Markierte Fragen",
      unattemptedQuestions: "Unversuchte Fragen",
      codingQuestions: "Codierungsfragen:",
      objectiveQuestions: "Objektive Fragen:",
      goToSections: "Gehen Sie zu den Abschnitten",
      lowWordCountWarning:
        "Ihre Antwort auf die Frage {{questionTitle}} besteht aus weniger als 40 Wörtern. Wenn Sie zur Abschnittsliste zurückkehren, wird diese Antwort verworfen.",
      videoNotSubmittedWarning:
        "Ihr aufgezeichnetes Video für die Frage {{questionTitle}} wurde nicht übermittelt. Wenn Sie zur Abschnittsliste zurückkehren, wird diese Antwort verworfen."
    },
    objective: {
      questionCounter: "Frage",
      marks: "Markierungen:",
      explanation: "Erläuterung",
      hints: "Hinweise",
      reset: "Zurücksetzen",
      flag: "Flagge",
      unflag: "Flagge entfernen",
      previous: "Vorherige",
      saveAndNext: "Speichern und weiter",
      saveAndViewSummary: "Abschnittszusammenfassung speichern und anzeigen",
      next: "Nächste",
      viewSectionSummary: "Abschnittszusammenfassung anzeigen",
      hideExplanation: "Erklärung ausblenden",
      showExplanation: "Erklärung anzeigen",
      hintWaitTooltip:
        "Sie müssen warten, bis Sie einen weiteren Hinweis sehen",
      noHintsPendingTooltip: "Es liegen keine Hinweise vor",
      selectOptionForExplanation:
        "Wählen Sie eine Option aus, um die Erläuterung der ausgewählten Option anzuzeigen"
    },
    tour: {
      shared: {
        timer:
          "Dieser Timer zeigt die verbleibende Zeit für Ihre Beurteilung an. Bitte überwachen Sie es genau, um sicherzustellen, dass Sie alle Abschnitte innerhalb der vorgegebenen Zeit abschließen.",
        submit:
          "Sobald Sie alle Abschnitte der Bewertung abgeschlossen haben, können Sie Ihre Arbeit einreichen, indem Sie auf die Schaltfläche „Bewertung absenden“ klicken. Durch diese Aktion werden Ihre Antworten finalisiert und Sie können nach der Übermittlung keine Änderungen mehr vornehmen. Stellen Sie sicher, dass Sie alle Ihre Antworten überprüft haben, bevor Sie mit der Einreichung fortfahren."
      },
      dashboard: {
        legend:
          "Die Abschnittsstatuslegende hilft Ihnen, Ihren Fortschritt während der Bewertung zu verstehen. Mithilfe eindeutiger Indikatoren wird angezeigt, ob ein Abschnitt noch nicht begonnen wurde, gerade bearbeitet wird oder abgeschlossen ist. Dadurch können Sie schnell beurteilen, welche Teile noch Ihre Aufmerksamkeit erfordern, und Ihre Zeit effektiv verwalten.",
        sectionCard:
          "Die Abschnittskarte bietet einen detaillierten Überblick über jeden Bewertungsabschnitt. Es zeigt den Abschnittstitel, seinen aktuellen Status und wichtige Informationen zu den Fragen innerhalb des Abschnitts an. Dazu gehören die Gesamtzahl der Fragen, die Anzahl der markierten Fragen und die Anzahl der beantworteten Fragen. Mithilfe der Abschnittskarte können Sie Ihren Fortschritt überwachen und Bereiche identifizieren, die möglicherweise mehr Aufmerksamkeit erfordern."
      },
      coding: {
        titles:
          "Oben auf der Seite finden Sie eine übersichtliche Anzeige des Bewertungstitels und des Abschnittstitels. Dies hilft Ihnen, den Überblick über Ihre aktuelle Aufgabe zu behalten und stellt sicher, dass Sie den spezifischen Abschnitt kennen, an dem Sie gerade arbeiten. Sehen Sie sich diese Titel an, um sich beim Navigieren durch die Fragen zurechtzufinden.",
        sectionsButton:
          "Mit dieser Schaltfläche können Sie ganz einfach zurück zum Abschnitts-Dashboard navigieren. Verwenden Sie diese Option, um zur Hauptübersicht Ihrer Bewertung zurückzukehren, wo Sie den Fortschritt aller Abschnitte anzeigen und verwalten können. Es bietet eine schnelle Möglichkeit, Ihren Gesamtfortschritt neu zu bewerten, ohne dass Ihre aktuelle Arbeit verloren geht.",
        sidebar:
          "Die Seitenleiste bietet einen Überblick über alle Fragen im aktuellen Abschnitt, den Sie beantworten. Sie können schnell zwischen den Fragen navigieren, indem Sie einfach den entsprechenden Block auswählen. Jeder Fragenblock ist je nach Status farblich gekennzeichnet, sodass Sie Ihren Fortschritt leicht verfolgen und bei Bedarf zu bestimmten Fragen springen können.",
        questionCard:
          "Diese Karte enthält die Frage, an der Sie gerade arbeiten, mit der vollständigen Eingabeaufforderung und allen relevanten Anweisungen oder Eingabeanforderungen. Es soll Ihnen einen klaren Überblick über die anstehende Aufgabe geben und alle notwendigen Informationen enthalten, um fortzufahren. Sie finden auch eine Schaltfläche, mit der Sie die Frage zur späteren Überprüfung markieren können, sodass Sie sie bei Bedarf problemlos erneut aufrufen können. Darüber hinaus gibt es Navigationsschaltflächen, mit denen Sie zur nächsten oder vorherigen Frage wechseln können, ohne zur Seitenleiste zurückkehren zu müssen, um einen reibungslosen und effizienten Fortschritt durch die Bewertung zu gewährleisten.",
        editor:
          "Im Code-Editor schreiben und ändern Sie Ihre Lösungen. Sie können zwischen verschiedenen Programmiersprachen wechseln, um den Anforderungen jeder Frage gerecht zu werden. Darüber hinaus haben Sie die Möglichkeit, das Design des Editors anzupassen, um das Codieren komfortabler zu gestalten. Wenn Sie mehr Platz auf dem Bildschirm bevorzugen, kann der Editor auf die volle Breite erweitert werden, sodass Sie einen größeren Bereich zum Arbeiten haben. Diese Funktionen sollen eine flexible und benutzerfreundliche Umgebung bieten, während Sie Ihre Codierungsaufgaben erledigen."
      }
    },
    toast: {
      proctoringViolationDetected:
        "Verstoß gegen die Aufsichtspflicht festgestellt",
      messages: {
        forbiddenObjectDetected: "Verbotenes Objekt erkannt",
        noFaceDetected: "Kein Gesicht erkannt",
        multipleFacesDetected: "Mehrere Gesichter erkannt",
        lookingAwayFromScreen: "Vom Bildschirm wegschauen",
        notLookingAtScreen: "Ich schaue nicht auf den Bildschirm",
        faceNotOrientedCorrectly: "Gesicht nicht richtig ausgerichtet",
        eyesNotFullyOpen: "Augen nicht vollständig geöffnet",
        copyNotAllowed: "Das Kopieren ist nicht gestattet",
        cutRestricted: "Im Überwachungsmodus ist das Schneiden eingeschränkt",
        pasteNotAllowed: "Einfügen ist nicht erlaubt",
        contextMenuNotAllowed: "Das Öffnen des Kontextmenüs ist nicht erlaubt"
      }
    },
    whatsNext: {
      heading: "Was kommt als nächstes?",
      attemptsRemaining: "verbleibende Versuche",
      passed: {
        shareLinkedInTitle: "Auf LinkedIn teilen",
        shareLinkedInSubtitle:
          "Feiern Sie Ihren Erfolg mit Ihrem beruflichen Netzwerk.",
        viewCertificateTitle: "Zertifikat anzeigen",
        viewCertificateSubtitle:
          "Laden Sie Ihre Zertifizierung jederzeit herunter oder greifen Sie darauf zu.",
        shareGloTitle: "Erfahrung teilen",
        shareGloSubtitle:
          "Inspirieren Sie Kollegen, indem Sie Ihre Erfolge intern veröffentlichen."
      },
      failed: {
        reviewLearningResourcesTitle: "Sehen Sie sich die Lernressourcen an",
        reviewLearningResourcesSubtitle:
          "Stärken Sie die Fähigkeit, die Aufmerksamkeit erfordert.",
        retakeAssessmentTitle: "Bewertung wiederholen",
        retakeAssessmentSubtitle:
          "Demonstrieren Sie Ihren Fortschritt und Ihr aktualisiertes Verständnis."
      },
      modal: {
        title: "Erfolg teilen",
        linkedInPostLabel: "Auf LinkedIn als Beitrag teilen",
        linkedInProfileLabel:
          "Als Zertifizierung zum LinkedIn-Profil hinzufügen",
        gloLabel: "Teilen auf Glo",
        comingSoon: "Kommt bald",
        infoMessage: "Zum Teilen müssen Sie auf der Plattform angemeldet sein."
      }
    },
    time: {
      hour_one: "{{count}} Stunde",
      hour_other: "{{count}} Stunden",
      minute_one: "{{count}} Minute",
      minute_other: "{{count}} Minuten",
      hourShort: "Std",
      minuteShort: "Min",
      secondShort: "Sek"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} Ergebnisse werden verarbeitet",
        title: "Ihre Ergebnisse werden verarbeitet",
        description:
          "Wir überprüfen Ihre {{featureName}} noch. Bitte schauen Sie in Kürze noch einmal vorbei!"
      },
      coolOffPeriod: {
        alt: "Abkühlphase",
        title: "Nächster Versuch bald verfügbar",
        completedAttempt:
          "Sie haben hierfür bereits einen Versuch durchgeführt",
        nextAttemptIntro: ". Ihr nächster Versuch wird in verfügbar sein"
      },
      maxAttemptExceeded: {
        alt: "Maximale Anzahl an Versuchen erreicht",
        title: "Maximale Anzahl an Versuchen erreicht",
        description:
          "Sie haben alle verfügbaren Versuche für diese {{featureName}} verwendet. Es können keine weiteren Versuche unternommen werden."
      },
      scheduleNotStarted: {
        alt: "Zeitplan nicht gestartet",
        title: "{{featureName}} Noch nicht gestartet",
        scheduledPrefix: "Der",
        scheduledOn: "soll am beginnen",
        checkBack:
          "Bitte schauen Sie noch einmal in {{time}} vorbei oder aktualisieren Sie, sobald die Zeit beginnt."
      },
      scheduleTimeCompleted: {
        alt: "Planzeit abgeschlossen",
        title: "{{featureName}} Fenster geschlossen",
        description:
          "Die geplante Zeit für diesen {{featureName}} ist abgelaufen. Sie können keinen Versuch mehr starten oder absenden."
      }
    },
    attemptDetails: {
      allAttempts: "Alle Versuche",
      headers: {
        attempt: "Versuchen",
        attemptedOn: "Versucht weiter",
        percentage: "Prozentsatz"
      },
      viewAllAttempts: "Alle Versuche anzeigen"
    },
    survey: {
      questions: {
        q1: "Auf einer Skala von 1 bis 5, wie klar fanden Sie die {{featureName}}-Fragen?",
        q2: "Ich fühlte mich ausreichend auf die in der {{featureName}} besprochenen Themen vorbereitet",
        q3: "Die für {{featureName}} verwendete Plattform war benutzerfreundlich und funktional",
        q4: "Ich glaube, dass meine Antworten meine Fähigkeiten und mein Wissen wirkungsvoll unter Beweis gestellt haben"
      },
      stronglyDisagree: "Stimme überhaupt nicht zu",
      stronglyAgree: "Stimme voll und ganz zu",
      submitFeedback: "Geben Sie Feedback ab"
    },
    cameraPreview: {
      loadingAlt: "Kameravorschau wird geladen",
      delayedMessage:
        "Die Kalibrierung dauert aufgrund eines langsamen Netzwerks länger als erwartet. Bitte warten Sie oder versuchen Sie, die Seite zu aktualisieren."
    },
    proctoring: {
      engineLoadFailedStatus:
        "Das Laden der Proctoring-Engine ist fehlgeschlagen",
      runtimeErrors: {
        cameraPermissionDenied:
          "Der Kamerazugriff wird durch Browser-Berechtigungseinstellungen blockiert.",
        cameraUnavailable:
          "Die Kamera ist nicht verfügbar oder wird derzeit von einer anderen Anwendung verwendet.",
        unableToLoadModel:
          "Das Überwachungsobjekterkennungsmodell kann nicht geladen werden.",
        webglRecoveryFailed:
          "Die WebGL-Wiederherstellung ist beim Wiederherstellen der Objekterkennung fehlgeschlagen."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine konnte nicht geladen werden:",
        videoPlayRejected: "Video play() abgelehnt:",
        cameraTrackEnded:
          "Kameraverfolgung beendet – erneute Aufnahme versucht",
        cameraReacquired: "Kamera wurde bei Versuch erneut erfasst {{attempt}}",
        cameraReacquireAttemptFailed:
          "Der Versuch, die Kamera erneut zu erfassen {{attempt}}, ist fehlgeschlagen:",
        cameraReacquireFailedAll:
          "Die erneute Erfassung der Kamera ist nach allen Versuchen fehlgeschlagen. In jedem Zyklus wird „cameraDisconnected“ gemeldet",
        uploadFailedQueued:
          "Der beaufsichtigte Upload ist nach {{attempts}} Versuchen fehlgeschlagen und steht in der Warteschlange für einen erneuten Versuch:",
        uploadAttemptFailedRetrying:
          "Der beaufsichtigte Upload-Versuch {{attempt}} ist fehlgeschlagen, es wird erneut versucht...",
        drainedQueuedViolation:
          "Entleerter Verstoß in der Warteschlange: {{violationType}} ({{remaining}} verbleibend)",
        queueDrainFailed:
          "Warteschlangenentleerung fehlgeschlagen, wird im nächsten Zyklus erneut versucht:",
        cocoLoadFailed: "Laden der COCO-SSD fehlgeschlagen:",
        faceProcessingError: "Fehler bei der Gesichtsverarbeitung:",
        errorProcessingFrame: "Fehlerverarbeitungsrahmen:",
        faceMeshInitError: "Fehler bei der Initialisierung des Gesichtsnetzes:"
      }
    }
  }
} as const;

export default de;
